// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const Feed = require('client-v2/common/containers/feed/component-dumb')
const { createFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')
const articleModelActions = require('client-v2/common/models/article/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Sibling imports
const feedActions = require('./actions')
const feedSelectors = require('./selectors')

const commonFeedSmartComponent = createFeedSmartComponent(feedActions, feedSelectors)

function mapStateToProps(state, ownProps) {
  return {
    ...commonFeedSmartComponent.mapStateToProps(state, ownProps),
    trailingComponent: feedSelectors.emptyCardState(state),
    emptyMessage: feedSelectors.emptyMessageState(state),
    profileUser: state.profileUser
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    ...commonFeedSmartComponent.mapDispatchToProps(dispatch),
    onAddUrlClick: dispatchAction(articleModelActions.showAddUrlModal)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    Feed
  )
)
